// extracted by mini-css-extract-plugin
export default {"tags-select":"tags-select__VeDF0","tags-select-focus":"tags-select-focus__zjV6q"};